var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vx-tooltip',{attrs:{"text":_vm.$t('login_as', { name: _vm.username })}},[_c('vs-button',{attrs:{"color":"warning","type":"border","icon-pack":"feather","icon":"icon-user","size":"small"},on:{"click":function($event){$event.preventDefault();return _vm.impersonify.apply(null, arguments)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }